<template>
  <div class="MoreUpload">
    <div v-for="item in successful" :key="item.name" class="upload-list">
      <img :src="item.url">
      <div class="demo-upload-list-cover">
        <i class="el-icon-view" @click="View(item)"></i>
        <i class="el-icon-delete" @click="Remove(item)"></i>
      </div>
    </div>
    <el-upload ref="upload" v-loading="loading" class="upload-demo" action="#" :multiple="true" :on-remove="handleRemove" :on-change="handleChange" :file-list="fileList" list-type="picture-card" :http-request="uploadFile" :auto-upload="false">
      <i slot="trigger" class="el-icon-plus"></i>
      <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
      <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
    </el-upload>
    <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
    <el-dialog :visible.sync="dialogVisible" :modal="false" width="35%">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      default: ''
    }
  },
  data() {
    return {
      fileData: '', // 文件上传数据（多文件合一）
      fileList: [], // upload多文件数组
      successful: [],
      loading: false,
      dialogVisible: false,
      dialogImageUrl: ''
    }
  },
  computed: {},
  watch: {
    successful: {
      immediate: true,
      deep: true,
      handler: function (data) {
        this.$emit('input', data.reduce((total, item) => {
          if (item.url) {
            total.push(item.url)
          }
          return total
        }, []))
      }
    },
    value: {
      immediate: true,
      deep:true,
      handler: function (data, old) {
        if (!old && data) {
          this.successful = data.map(item => {
            return {
              url: item,
              name: Date.now()
            }
          })
        } else if (!data && old) {
          this.successful = []
        }
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    uploadFile(file) {
      this.fileData.append('files', file.file) // append增加数据console.log(file)
    },
    submitUpload(data) {
      console.log(data, '这里面有什么')
      const fileStay = this.fileList.every((file) => file.raw === undefined)
      if (fileStay) {
        this.messages('请先选择文件', false)
      } else {
        const size = this.fileList.every(
          (file) => file.size / 1024 / 1024 < 2
        )
        const maxSize = this.fileList.map((item) => {
          return item.size / 1024 / 1024
        })
        if (!size) {
          this.messages('请检查，上传单个文件大小不能超过10MB!', false)
          return
        }
        if (this.ArraySum(maxSize) > 20) {
          this.messages('请检查，上传总大小不能超过100MB!', false)
          return
        }
        this.fileData = new FormData() // new formData对象
        this.loading = true
        this.$refs.upload.submit() // 提交调用uploadFile函数
        this.$UploadFile.uploadFileS(this.fileData).then(({ data }) => {
          if (data.code === 200) {
            this.loading = false
            this.fileList = []
            data.result.forEach((item) => {
              this.successful.push({
                name: Date.now(),
                showProgress: true,
                progress: 0,
                url: item
              })
            })
          }
        }).catch((err) => {
          this.loading = false
          console.log(err)
        })
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    clear(){
      this.successful = []
    },
    View(item) {
      this.dialogVisible = true
      this.dialogImageUrl = item.url
    },
    Remove(file) {
      const successful = this.successful
      this.successful.splice(successful.indexOf(file), 1)
    },
    // 监控上传文件列表
    handleChange(file, fileList) {
      const existFile = fileList
        .slice(0, fileList.length - 1)
        .find((f) => f.name === file.name)
      if (existFile) {
        setTimeout(() => {
          this.messages('当前文件已经存在!', false)
        })
        fileList.pop()
      }
      this.fileList = fileList
    },
    ArraySum(ary) {
      if (ary.length > 0) {
        var sum = ary.reduce(function (prev, cur,) {
          return prev + cur
        })
        return sum
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.MoreUpload {
  // display: flex;
  .upload-list {
    display: inline-block;
    width: 90px;
    height: 90px;
    text-align: center;
    line-height: 90px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
    img {
      width: 100%;
      height: 100%;
    }
    .demo-upload-list-cover {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.6);
      i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
      }
    }
    &:hover .demo-upload-list-cover {
      display: block;
    }
  }
  >>> .el-upload {
    width: 90px;
    height: 90px;
    line-height: 95px;
  }
  >>> .el-upload-list__item {
    width: 90px;
    height: 90px;
  }
}
</style>
